import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { getTheme, mergeStyles } from "@fluentui/react/lib/Styling";
import { Stack } from "@fluentui/react/lib/Stack";
import "../Icon/index.js";
import "../Heading.js";
import { Icon } from "../Icon/Icon.js";
import { Heading } from "../Heading/Heading.js";
class NoContentMessage extends React.Component {
  render() {
    const { iconName, heading, description, iconSize, children } = this.props;
    const theme = getTheme();
    return /* @__PURE__ */ jsx(Stack, { verticalFill: true, horizontalAlign: "center", verticalAlign: "center", styles: { root: { minHeight: "175px" } }, children: /* @__PURE__ */ jsx(Stack.Item, { children: /* @__PURE__ */ jsxs("div", { style: { textAlign: "center" }, children: [
      /* @__PURE__ */ jsx(
        Icon,
        {
          ariaLabel: ``,
          "aria-hidden": "true",
          iconName,
          style: {
            /**
             * Hack to override hard-coded styles
             * default style should be migrated to styles prop in core Icon component
             */
            width: "100%"
          },
          styles: { root: { width: "100%", fontSize: `${iconSize || 85}px`, color: theme.palette.neutralTertiaryAlt } }
        }
      ),
      /* @__PURE__ */ jsxs("div", { children: [
        !!heading && /* @__PURE__ */ jsx(
          Heading,
          {
            tag: "h2",
            className: mergeStyles({
              fontSize: "16px",
              lineHeight: "22px"
            }),
            children: heading
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: mergeStyles({
              fontSize: "14px",
              lineHeight: "20px"
            }),
            children: typeof description === "function" ? description() : description
          }
        )
      ] }),
      /* @__PURE__ */ jsx("div", { children })
    ] }) }) });
  }
}
export {
  NoContentMessage
};
//# sourceMappingURL=NoContentMessage.js.map
